var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fotter"}},_vm._l((_vm.nav),function(i){return _c('span',{class:(_vm.navIndex.index==i.index?'navCheck':''),on:{"click":function($event){_vm.routerChange(i)}}},[_vm._v("\n\t\t"+_vm._s(i.name)+"\n\t")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7acc611e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fotter.vue
// module id = null
// module chunks = 